module.exports = __webpack_public_path__ + "img/daichao1.89ad45fa.png";